import { h } from 'preact';
import styles from './BirdsnestPagination.module.scss';
import nextArrow from '../../assets/icons/Frame.svg';
export function BirdsnestPagination({ meta, onChange, maxVisiblePages = 5 }) {
    const { currentPage, totalPages } = meta;
    if (totalPages <= 1)
        return null;
    // Generate page numbers with ellipsis logic
    const getPageNumbers = () => {
        const pages = [];
        if (totalPages <= maxVisiblePages + 2) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        }
        else {
            pages.push(1);
            if (currentPage <= 3) {
                for (let i = 2; i <= Math.min(4, totalPages - 1); i++) {
                    pages.push(i);
                }
                if (totalPages > 5)
                    pages.push('ellipsis');
                pages.push(totalPages);
            }
            else if (currentPage >= totalPages - 2) {
                pages.push('ellipsis');
                for (let i = Math.max(totalPages - 3, 2); i <= totalPages; i++) {
                    pages.push(i);
                }
            }
            else {
                pages.push('ellipsis');
                for (let i = currentPage - 1; i <= currentPage + 1; i++) {
                    pages.push(i);
                }
                pages.push('ellipsis');
                pages.push(totalPages);
            }
        }
        return pages;
    };
    const pageNumbers = getPageNumbers();
    return (h("div", { class: `${styles.pagination} birdsnest-pagination` },
        h("div", { class: styles.paginationInner },
            pageNumbers.map((page, index) => {
                if (page === 'ellipsis') {
                    return (h("span", { key: `ellipsis-${index}`, class: styles.ellipsis }, "..."));
                }
                return (h("button", { key: page, class: `${styles.pageBtn} ${page === currentPage ? styles.active : ''}`, onClick: () => onChange(page), disabled: page === currentPage, type: "button" }, page));
            }),
            currentPage < totalPages && (h("button", { class: styles.navBtn, onClick: () => onChange(currentPage + 1), type: "button", "aria-label": "Next page" },
                h("img", { src: nextArrow, alt: "Next Arrow" }))))));
}
